import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import CircularProgress from '@material-ui/core/CircularProgress'

import styles from './styles'

const Loader = ({ type, size, color, classes, sidebarOpen }) => (
  <div
    className={classnames({
      [classes[type]]: true,
      [classes.loader]: true,
    })}
  >
    <CircularProgress size={size} color={color} className={classes.progress} />
  </div>
)

Loader.defaultProps = {
  type: 'full',
}

Loader.propTypes = {
  type: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  classes: PropTypes.object.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ global }) => ({
  sidebarOpen: global.leftNavigation.open,
})

const enhancer = compose(withStyles(styles), connect(mapStateToProps))

export default enhancer(Loader)
